// extracted by mini-css-extract-plugin
module.exports = {"basicRatios":"basic-ratios-module--basic-ratios--kzpay","basicRatios__row":"basic-ratios-module--basic-ratios__row--FRFUE"};